"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFilterableSelectionListWithFilters = exports.useFilterableSelectionList = exports.defaultFilterFunction = exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactVirtualized = require("react-virtualized");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseTranslation = require("nicbase-translation");

var _filterInput = _interopRequireDefault(require("./filter-input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var defaultFilterFunction = function defaultFilterFunction(_ref) {
  var label = _ref.label,
      inputValue = _ref.inputValue;
  return String(label !== null && label !== void 0 ? label : '').toLocaleLowerCase().includes(String(inputValue).toLocaleLowerCase());
};

exports.defaultFilterFunction = defaultFilterFunction;

var init = function init(initialSelectedRows) {
  return initialSelectedRows;
};

var initialFilter = {
  values: [],
  inputValue: ''
};

var listReducer = function listReducer(state, action) {
  switch (action.type) {
    case 'select':
      {
        var value = action.value;
        return [].concat(_toConsumableArray(state), [value]);
      }

    case 'unselect':
      {
        var _value = action.value;
        return state.filter(function (existingValue) {
          return existingValue !== _value;
        });
      }

    case 'selectAll':
      {
        var _action$values = action.values,
            values = _action$values === void 0 ? [] : _action$values;
        return Array.from(new Set([].concat(_toConsumableArray(state), _toConsumableArray(values))));
      }

    case 'reset':
      {
        return [];
      }

    default:
      {
        throw new Error("Unhandled action type: ".concat(action.type));
      }
  }
};
/**
 * Custom hook that simplifies usage of FilterableSelectionList, by managing selected rows and filter input of the selection list.
 * The returned props can also be used from other code to change viewed parts of the controlled selection list.
 */


var useFilterableSelectionList = function useFilterableSelectionList() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$initialInputVal = _ref2.initialInputValue,
      initialInputValue = _ref2$initialInputVal === void 0 ? '' : _ref2$initialInputVal,
      _ref2$initialSelected = _ref2.initialSelectedRows,
      initialSelectedRows = _ref2$initialSelected === void 0 ? [] : _ref2$initialSelected;

  var _useState = (0, _react.useState)(initialInputValue),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var onInputChange = (0, _react.useCallback)(function (value) {
    return setInputValue(value !== null && value !== void 0 ? value : '');
  }, []);

  var _useReducer = (0, _react.useReducer)(listReducer, initialSelectedRows, init),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      selectedRows = _useReducer2[0],
      dispatch = _useReducer2[1];

  var onReset = (0, _react.useCallback)(function () {
    return dispatch({
      type: 'reset'
    });
  }, []);
  var onSelectAll = (0, _react.useCallback)(function (values) {
    return dispatch({
      type: 'selectAll',
      values: values
    });
  }, []);
  var onSelect = (0, _react.useCallback)(function (value, isSelected) {
    if (isSelected) {
      dispatch({
        type: 'select',
        value: value
      });
    } else {
      dispatch({
        type: 'unselect',
        value: value
      });
    }
  }, []);
  return {
    inputValue: inputValue,
    onInputChange: onInputChange,
    selectedRows: selectedRows,
    onSelect: onSelect,
    onReset: onReset,
    onSelectAll: onSelectAll
  };
};

exports.useFilterableSelectionList = useFilterableSelectionList;

var useFilterableSelectionListWithFilters = function useFilterableSelectionListWithFilters(key, filters) {
  var filter = (0, _react.useMemo)(function () {
    var _filters$values$key, _filters$values;

    return (_filters$values$key = (_filters$values = filters.values) === null || _filters$values === void 0 ? void 0 : _filters$values[key]) !== null && _filters$values$key !== void 0 ? _filters$values$key : initialFilter;
  }, [filters.values, key]);
  var update = (0, _react.useCallback)(function (_ref3) {
    var _ref3$values = _ref3.values,
        values = _ref3$values === void 0 ? filter.values : _ref3$values,
        _ref3$inputValue = _ref3.inputValue,
        inputValue = _ref3$inputValue === void 0 ? filter.inputValue : _ref3$inputValue;
    return filters.update(_defineProperty({}, key, {
      values: values,
      inputValue: inputValue
    }));
  }, [filter.inputValue, filter.values, filters, key]);
  var onInputChange = (0, _react.useCallback)(function (value) {
    return update({
      inputValue: value !== null && value !== void 0 ? value : ''
    });
  }, [update]);
  var onSelect = (0, _react.useCallback)(function (value, isSelected) {
    var newValues;

    if (isSelected) {
      newValues = [].concat(_toConsumableArray(filter.values), [value]);
    } else {
      newValues = filter.values.filter(function (existingValue) {
        return existingValue !== value;
      });
    }

    update({
      values: newValues
    });
  }, [filter.values, update]);
  var onSelectAll = (0, _react.useCallback)(function (values) {
    update({
      values: Array.from(new Set([].concat(_toConsumableArray(filter.values), _toConsumableArray(values))))
    });
  }, [filter.values, update]);
  var onReset = (0, _react.useCallback)(function () {
    update({
      values: []
    });
  }, [update]);
  return {
    inputValue: filter.inputValue,
    selectedRows: filter.values,
    onInputChange: onInputChange,
    onSelect: onSelect,
    onReset: onReset,
    onSelectAll: onSelectAll
  };
};

exports.useFilterableSelectionListWithFilters = useFilterableSelectionListWithFilters;

var FilterableSelectionList = function FilterableSelectionList(_ref4) {
  var className = _ref4.className,
      data = _ref4.data,
      selectedRows = _ref4.selectedRows,
      hideSelectAll = _ref4.hideSelectAll,
      hideReset = _ref4.hideReset,
      inputValue = _ref4.inputValue,
      onInputChange = _ref4.onInputChange,
      onSelect = _ref4.onSelect,
      onReset = _ref4.onReset,
      onSelectAll = _ref4.onSelectAll,
      filterInputLabel = _ref4.filterInputLabel,
      optionRenderer = _ref4.optionRenderer,
      hideFilterInput = _ref4.hideFilterInput,
      filterFunction = _ref4.filterFunction;
  // focus filter input initially
  var filterInput = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (!hideFilterInput) {
      filterInput.current.focus();
    }
  }, [hideFilterInput]); // use input value to filter data by label (debounced)

  var debouncedInputValue = (0, _hooks.useDebounce)(inputValue, 300);
  var filteredData = (0, _react.useMemo)(function () {
    return data.filter(function (row) {
      return filterFunction({
        label: row.label,
        inputValue: debouncedInputValue
      });
    });
  }, [data, debouncedInputValue, filterFunction]); // cache for already measured rows (height)

  var measurementCache = (0, _react.useRef)(new _reactVirtualized.CellMeasurerCache({
    fixedWidth: true
  }));
  var prevFiltered = (0, _hooks.usePrevious)(filteredData); // if data changed (e.g filtered) reset cache

  if (prevFiltered !== filteredData) {
    measurementCache.current.clearAll();
  } // render a row, measure its dimensions and cache them for reuse


  var createRow = (0, _react.useCallback)(function (_ref5) {
    var parent = _ref5.parent,
        index = _ref5.index,
        key = _ref5.key,
        style = _ref5.style;
    var _filteredData$index = filteredData[index],
        value = _filteredData$index.value,
        label = _filteredData$index.label;
    var isSelected = selectedRows.includes(value);

    var onOptionSelect = function onOptionSelect(isChecked) {
      measurementCache.current.clear(index);
      onSelect(value, isChecked);
    };

    return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.CellMeasurer, {
      cache: measurementCache.current,
      columnIndex: 0,
      rowIndex: index,
      key: key,
      parent: parent
    }, /*#__PURE__*/_react["default"].createElement("div", {
      key: key,
      style: style
    }, optionRenderer ? optionRenderer({
      value: value,
      label: label,
      isSelected: isSelected,
      onOptionSelect: onOptionSelect
    }) : /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
      checked: isSelected,
      value: value,
      label: label,
      onChange: onOptionSelect
    })));
  }, [filteredData, onSelect, optionRenderer, selectedRows]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('overflow-hidden p-2 flex flex-col', className)
  }, !hideFilterInput && /*#__PURE__*/_react["default"].createElement(_filterInput["default"], {
    ref: filterInput,
    value: inputValue,
    onChange: onInputChange,
    label: filterInputLabel
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 mt-2"
  }, /*#__PURE__*/_react["default"].createElement(_reactVirtualized.AutoSizer, null, function (_ref6) {
    var height = _ref6.height,
        width = _ref6.width;
    return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.List, {
      className: "outline-none",
      deferredMeasurementCache: measurementCache.current,
      height: height,
      width: width,
      rowCount: filteredData.length,
      rowRenderer: createRow,
      rowHeight: measurementCache.current.rowHeight
    });
  })), !hideSelectAll && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    primary: true,
    raised: true,
    className: "text-sm mt-2",
    onClick: function onClick() {
      measurementCache.current.clearAll();
      onSelectAll(filteredData.map(function (row) {
        return row.value;
      }));
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.selectAll",
    tagName: "span"
  })), !hideReset && selectedRows.length !== 0 && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    className: "text-primary text-sm mt-2",
    onClick: function onClick() {
      measurementCache.current.clearAll();
      onReset();
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "filters.reset",
    tagName: "span"
  })));
};

FilterableSelectionList.propTypes = {
  className: _propTypes["default"].string,
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    label: _propTypes["default"].node
  })),
  hideSelectAll: _propTypes["default"].bool,
  hideReset: _propTypes["default"].bool,
  inputValue: _propTypes["default"].string,
  selectedRows: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
  onInputChange: _propTypes["default"].func,
  onSelect: _propTypes["default"].func,
  onSelectAll: _propTypes["default"].func,
  onReset: _propTypes["default"].func,
  filterInputLabel: _propTypes["default"].node,
  optionRenderer: _propTypes["default"].func,
  hideFilterInput: _propTypes["default"].bool,
  filterFunction: _propTypes["default"].func
};

var noop = function noop() {};

FilterableSelectionList.defaultProps = {
  className: '',
  hideSelectAll: false,
  hideReset: false,
  data: [],
  selectedRows: [],
  inputValue: '',
  filterInputLabel: '',
  onInputChange: noop,
  onSelect: noop,
  onSelectAll: noop,
  onReset: noop,
  optionRenderer: null,
  hideFilterInput: false,
  filterFunction: defaultFilterFunction
};
var _default = FilterableSelectionList;
exports["default"] = _default;